/**
 * product.js - Product page functionality
 * Event delegation only, no globals, CustomEvents
 * Shared by standard + LP templates
 */
(function() {
  'use strict';

  var productStrings = (window.LinaskyStrings && window.LinaskyStrings.product) || {};
  var productErrorStrings = (window.LinaskyStrings && window.LinaskyStrings.productErrors) || {};
  function tProduct(key, fallback) {
    return productStrings[key] || fallback || '';
  }
  function tProductError(key, fallback, values) {
    var text = productErrorStrings[key] || fallback || '';
    if (values) {
      Object.keys(values).forEach(function(name) {
        text = text.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), values[name]);
      });
    }
    return text;
  }

  // Bundle Helper with Caching
  var BundleHelper = (function() {
    var cachedSelector = null;
    
    function getCheckedBundle() {
      if (!cachedSelector) {
        cachedSelector = document.querySelector('[data-bundle-selector]');
      }
      if (!cachedSelector) return null;
      
      return cachedSelector.querySelector('input[name="bundle-quantity"]:checked');
    }
    
    function invalidateCache() {
      cachedSelector = null;
    }
    
    document.addEventListener('bundle:changed', invalidateCache);
    
    return {
      getChecked: getCheckedBundle,
      invalidate: invalidateCache
    };
  })();

  function getProductData() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getMoneyFormat() {
    var meta = document.querySelector('meta[name="money-format"]');
    return meta ? meta.getAttribute('content') : '${{amount}}';
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = parseFloat(cents) / 100;

    var currency = document.documentElement.getAttribute('data-currency') ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      '';
    var iso = currency.toUpperCase();
    if (iso === 'EUR') {
      var eur = value.toFixed(2).replace('.', ',');
      if (eur.endsWith(',00')) eur = eur.slice(0, -3);
      return eur + ' €';
    }
    var symbols = { USD: '$', CAD: '$', AUD: '$', NZD: '$', GBP: '£' };
    if (symbols[iso]) {
      var amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (amount.endsWith('.00')) amount = amount.slice(0, -3);
      return symbols[iso] + amount;
    }

    var formatString = format || getMoneyFormat();
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    
    var placeholder = match[1];
    var formattedValue;
    
    switch (placeholder) {
      case 'amount':
        formattedValue = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_no_decimals':
        formattedValue = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_with_comma_separator':
        formattedValue = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      default:
        formattedValue = value.toFixed(2);
    }
    
    return formatString.replace(placeholderRegex, formattedValue);
  }

  function initGallery() {
    var gallery = document.querySelector('[data-product-hero]');
    if (!gallery) return;

    var scroll = gallery.querySelector('[data-gallery-scroll]');
    var thumbs = gallery.querySelectorAll('[data-thumb-index]');
    var dots = gallery.querySelectorAll('[data-dot-index]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var slides = gallery.querySelectorAll('[data-slide-index]');
    
    if (!scroll || slides.length === 0) return;

    function goToSlide(index, instant) {
      var slide = slides[index];
      if (!slide) return;
      scroll.scrollTo({
        left: slide.offsetLeft,
        behavior: instant ? 'instant' : 'smooth'
      });
      updateActiveThumbnail(index);
    }

    function updateActiveThumbnail(index) {
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      
      // Auto-scroll thumbnails to show active one
      var activeThumb = thumbs[index];
      if (activeThumb) {
        var thumbsContainer = activeThumb.parentElement;
        if (thumbsContainer) {
          var containerRect = thumbsContainer.getBoundingClientRect();
          var thumbRect = activeThumb.getBoundingClientRect();
          var scrollLeft = thumbsContainer.scrollLeft;
          var thumbCenter = thumbRect.left - containerRect.left + scrollLeft + (thumbRect.width / 2);
          var containerCenter = containerRect.width / 2;
          
          thumbsContainer.scrollTo({
            left: thumbCenter - containerCenter,
            behavior: 'smooth'
          });
        }
      }
    }

    function getCurrentIndex() {
      var scrollLeft = scroll.scrollLeft;
      var slideWidth = slides[0].offsetWidth;
      return Math.round(scrollLeft / slideWidth);
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(thumb.dataset.thumbIndex, 10);
        var current = getCurrentIndex();
        var distance = Math.abs(index - current);
        goToSlide(index, distance > 1);
      });
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(dot.dataset.dotIndex, 10);
        var current = getCurrentIndex();
        var distance = Math.abs(index - current);
        goToSlide(index, distance > 1);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var current = getCurrentIndex();
        goToSlide(Math.max(0, current - 1));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var current = getCurrentIndex();
        goToSlide(Math.min(slides.length - 1, current + 1));
      });
    }

    scroll.addEventListener('scroll', function() {
      var index = getCurrentIndex();
      updateActiveThumbnail(index);
    }, { passive: true });
  }

  var currentVariant = null;

  function initVariants() {
    var productData = getProductData();
    if (!productData) return;

    var variantInputs = document.querySelectorAll('select.variant-dropdown[data-option-index]');
    var variantSelect = document.querySelector('[data-variant-select]');
    var priceBlock = document.querySelector('#product-price');
    var addToCartBtn = document.querySelector('[data-add-to-cart]');

    if (!variantSelect || variantInputs.length === 0) return;

    // Set initial variant
    var initialVariantId = variantSelect.value;
    currentVariant = productData.variants.find(function(v) {
      return String(v.id) === String(initialVariantId);
    }) || productData.variants[0];

    function getSelectedOptions() {
      var options = [];
      variantInputs.forEach(function(select) {
        var index = parseInt(select.dataset.optionIndex, 10);
        options[index - 1] = select.value;
      });
      return options;
    }

    function findVariant(options) {
      return productData.variants.find(function(variant) {
        return options.every(function(opt, i) {
          var key = 'option' + (i + 1);
          return variant[key] === opt;
        });
      });
    }

    function updateUI(variant) {
      if (!variant) {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = '<span>' + tProduct('unavailable', 'Unavailable') + '</span>';
        }
        return;
      }

      currentVariant = variant;
      variantSelect.value = variant.id;

      var hasBundle = BundleHelper.getChecked();

      if (priceBlock) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
          html += '<span class="price-current price-sale">' + formatMoney(variant.price) + '</span>';
          var saving = variant.compare_at_price - variant.price;
          var savingMoney = formatMoney(saving).replace('.00', '').replace(',00', '');
          html += '<span class="price-badge">' + tProduct('savingsLabel', 'Save {{ amount }}').replace('{{ amount }}', savingMoney) + '</span>';
        } else {
          html += '<span class="price-current">' + formatMoney(variant.price) + '</span>';
        }
        priceBlock.innerHTML = html;
      }

      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          updateButtonPrice();
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = '<span>' + tProduct('soldOut', 'Sold Out') + '</span>';
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      document.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { variant: variant }
      }));
    }

    function syncVariantPills(select) {
      var index = select.dataset.optionIndex;
      if (!index) return;
      document.querySelectorAll('[data-variant-pill][data-option-index="' + index + '"]').forEach(function(pill) {
        var selected = pill.dataset.optionValue === select.value;
        pill.classList.toggle('is-selected', selected);
        pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    variantInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var options = getSelectedOptions();
        var variant = findVariant(options);
        updateUI(variant);
        syncVariantPills(input);
      });
    });

    document.querySelectorAll('[data-variant-pill]').forEach(function(pill) {
      pill.addEventListener('click', function(event) {
        event.preventDefault();
        if (pill.disabled) return;
        var index = pill.dataset.optionIndex;
        var select = document.querySelector('select.variant-dropdown[data-option-index="' + index + '"]');
        if (!select) return;
        select.value = pill.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Initial button update
    if (currentVariant && currentVariant.available) {
      updateButtonPrice();
    }
  }

  function calculateTotalPrice() {
    var checkedBundle = BundleHelper.getChecked();
    if (checkedBundle) {
      return parseInt(checkedBundle.dataset.price, 10) || 0;
    }
    
    if (!currentVariant) return 0;
    
    var total = currentVariant.price;
    var addonCheckboxes = document.querySelectorAll('[data-addon-checkbox]:checked');
    
    addonCheckboxes.forEach(function(checkbox) {
      var price = parseInt(checkbox.dataset.addonPrice, 10) || 0;
      total += price;
    });
    
    return total;
  }

  function calculateComparePrice() {
    var checkedBundle = BundleHelper.getChecked();
    if (checkedBundle) {
      var bundleComparePrice = parseInt(checkedBundle.dataset.comparePrice, 10) || 0;
      return bundleComparePrice;
    }
    
    if (!currentVariant) return 0;
    
    var hasPromo = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
    if (!hasPromo) return 0;
    
    var total = currentVariant.compare_at_price;
    var addonCheckboxes = document.querySelectorAll('[data-addon-checkbox]:checked');
    
    addonCheckboxes.forEach(function(checkbox) {
      var price = parseInt(checkbox.dataset.addonPrice, 10) || 0;
      total += price;
    });
    
    return total;
  }

  function updateButtonPrice() {
    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    
    if (!addToCartBtn) {
      return;
    }
    
    // Check if we have a bundle or a variant to display
    var checkedBundle = BundleHelper.getChecked();
    var hasVariant = currentVariant && currentVariant.available;
    
    if (!checkedBundle && !hasVariant) {
      return;
    }

    var total = calculateTotalPrice();
    var compareTotal = calculateComparePrice();
    var hasPromo = compareTotal > total;

    var atcText = addToCartBtn.dataset.addText || tProduct('addToCart', 'Add to Cart');
    var html = '<span class="atc-text">' + atcText + '</span>';
    html += '<span class="atc-sep" style="margin: 0 0.5rem; font-weight: 400;">•</span>';
    html += '<span class="atc-price" data-atc-price>' + formatMoney(total) + '</span>';
    
    addToCartBtn.innerHTML = html;
  }


  function initAccordion() {
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      var content = trigger.nextElementSibling;
      if (!content || !content.hasAttribute('data-accordion-content')) return;

      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      trigger.setAttribute('aria-expanded', !isExpanded);
      content.hidden = isExpanded;
    });
  }

  function initFaq() {
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-faq-trigger]');
      if (!trigger) return;

      var answer = trigger.nextElementSibling;
      if (!answer || !answer.hasAttribute('data-faq-answer')) return;

      var isOpen = trigger.classList.contains('is-open');
      
      // Close all other FAQ items with smooth animation
      document.querySelectorAll('[data-faq-trigger].is-open').forEach(function(openTrigger) {
        if (openTrigger !== trigger) {
          openTrigger.classList.remove('is-open');
          var openAnswer = openTrigger.nextElementSibling;
          if (openAnswer) {
            openAnswer.style.maxHeight = openAnswer.scrollHeight + 'px';
            setTimeout(function() {
              openAnswer.style.maxHeight = '0';
            }, 10);
            setTimeout(function() {
              openAnswer.hidden = true;
              openAnswer.style.maxHeight = '';
            }, 300);
          }
        }
      });

      // Toggle current item with smooth animation
      if (isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        setTimeout(function() {
          answer.style.maxHeight = '0';
        }, 10);
        setTimeout(function() {
          answer.hidden = true;
          answer.style.maxHeight = '';
          trigger.classList.remove('is-open');
        }, 300);
      } else {
        answer.hidden = false;
        answer.style.maxHeight = '0';
        setTimeout(function() {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }, 10);
        setTimeout(function() {
          answer.style.maxHeight = '';
        }, 300);
        trigger.classList.add('is-open');
      }
    });
  }

  function initAddons() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    // Listen to addon checkbox changes to update button price
    var addonCheckboxes = form.querySelectorAll('[data-addon-checkbox]');
    addonCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', updateButtonPrice);
    });

    // Listen to bundle changes
    document.addEventListener('bundle:changed', function() {
      updateButtonPrice();
    });
    
    // Initial button price update on page load
    if (currentVariant && currentVariant.available) {
      updateButtonPrice();
    }

    form.addEventListener('submit', function(e) {
      var checkedAddons = form.querySelectorAll('[data-addon-checkbox]:checked');
      var colorToggle = document.querySelector('#color-toggle');
      var isMultiColor = colorToggle && colorToggle.checked;
      var quantityInput = form.querySelector('[name="quantity"]');
      var quantity = quantityInput ? quantityInput.value : 1;
      var bundleQuantity = parseInt(quantity, 10);
      
      // Only intercept if we have addons OR multi-color mode OR bundle quantity > 1
      if (checkedAddons.length === 0 && !isMultiColor && bundleQuantity <= 1) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var variantSelect = form.querySelector('[data-variant-select]');
      if (!variantSelect || !variantSelect.value) {
        alert(tProductError('selectVariant', 'Please select a variant.'));
        return;
      }
      
      var mainVariantId = variantSelect.value;
      var items = [];
      
      if (isMultiColor && bundleQuantity > 1) {
        // Multi-color mode: check if using new simplified interface
        var colorQuantityRows = document.querySelectorAll('.additional-color-selectors .color-quantity-row');
        
        if (colorQuantityRows.length > 0) {
          // NEW SYSTEM: Use color quantity rows
          var variantCounts = {};
          var totalQuantity = 0;
          
          // Get current size
          var currentSize = null;
          var sizeNames = ['Taille', 'taille', 'Size', 'size', 'Größe', 'größe', 'Grösse', 'grösse', 'Talla', 'talla', 'Taglia', 'taglia'];
          for (var i = 0; i < sizeNames.length; i++) {
            var sizeInput = document.querySelector('input[name="' + sizeNames[i] + '"]:checked');
            if (sizeInput) {
              currentSize = sizeInput.value;
              break;
            }
          }
          
          if (!currentSize) {
            alert(tProductError('selectSize', 'Please select a size.'));
            return;
          }
          
          // Collect quantities from each color row
          colorQuantityRows.forEach(function(row) {
            var colorValue = row.dataset.colorValue;
            var qtyElement = row.querySelector('.color-qty');
            var qty = qtyElement ? parseInt(qtyElement.textContent, 10) : 0;
            
            if (qty > 0) {
              totalQuantity += qty;
              
              // Find variant ID for this color + size combination
              var variantId = window.findVariantIdForColorAndSize ? 
                window.findVariantIdForColorAndSize(colorValue, currentSize) : null;
              
              if (variantId && !isNaN(variantId) && variantId > 0) {
                if (variantCounts[variantId]) {
                  variantCounts[variantId] += qty;
                } else {
                  variantCounts[variantId] = qty;
                }
              }
            }
          });
          
          // Validate total quantity matches bundle quantity
          if (totalQuantity !== bundleQuantity) {
            alert(tProductError('bundleQuantityExact', 'Please distribute exactly {{ expected }} items (currently: {{ current }}).', {
              expected: bundleQuantity,
              current: totalQuantity
            }));
            return;
          }
          
          // Convert to items array
          for (var vid in variantCounts) {
            items.push({
              id: parseInt(vid, 10),
              quantity: variantCounts[vid]
            });
          }
          
          if (items.length === 0) {
            alert(tProductError('selectColor', 'Please select at least one color.'));
            return;
          }
          
        } else {
          // OLD SYSTEM: Use radio buttons (fallback)
          var variantCounts = {};
          
          // Add main color (Ensemble 1)
          var mainColorVariantId = parseInt(mainVariantId, 10);
          if (!mainColorVariantId || isNaN(mainColorVariantId)) {
            alert(tProductError('invalidVariant', 'Please select a valid variant.'));
            return;
          }
          variantCounts[mainColorVariantId] = 1;
          
          // Add additional ensemble colors (Ensemble 2, 3, etc.)
          var additionalSelectors = document.querySelectorAll('.additional-color-selectors input[type="radio"]:checked');
          
          // Validate we have enough color selections
          if (additionalSelectors.length < bundleQuantity - 1) {
            alert(tProductError('selectColorEach', 'Please select a color for each item.'));
            return;
          }
          
          additionalSelectors.forEach(function(radio) {
            var variantId = parseInt(radio.value, 10);
            
            // Validate variant ID
            if (!variantId || isNaN(variantId) || variantId <= 0) {
              return; // Skip invalid variants
            }
            
            if (variantCounts[variantId]) {
              variantCounts[variantId]++;
            } else {
              variantCounts[variantId] = 1;
            }
          });
          
          // Convert to items array
          for (var vid in variantCounts) {
            items.push({
              id: parseInt(vid, 10),
              quantity: variantCounts[vid]
            });
          }
        }
      } else {
        // Single color mode: add same variant multiple times
        items.push({
          id: parseInt(mainVariantId, 10),
          quantity: bundleQuantity
        });
      }

      // Add addons
      checkedAddons.forEach(function(checkbox) {
        var addonId = parseInt(checkbox.value, 10);
        if (addonId && !isNaN(addonId) && addonId > 0) {
          items.push({
            id: addonId,
            quantity: 1
          });
        }
      });

      // Validate items array
      if (items.length === 0) {
        alert(tProductError('emptyItems', 'No item to add to cart.'));
        return;
      }
      
      // Validate all items have valid IDs
      var hasInvalidItem = items.some(function(item) {
        return !item.id || isNaN(item.id) || item.id <= 0;
      });
      
      if (hasInvalidItem) {
        alert(tProductError('invalidVariant', 'Please select a valid variant.'));
        return;
      }

      var submitBtn = form.querySelector('[data-add-to-cart]');
      var addingText = submitBtn ? (submitBtn.dataset.addingText || tProduct('adding', '...')) : tProduct('adding', '...');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>' + addingText + '</span>';
      }

      document.dispatchEvent(new CustomEvent('cart:add', {
        detail: {
          items: items,
          source: 'product-form',
          onSuccess: function() {
            if (submitBtn) {
              submitBtn.innerHTML = '<span>' + tProduct('added', 'Added') + '</span>';
              setTimeout(function() {
                submitBtn.disabled = false;
                updateButtonPrice();
              }, 1500);
            }
          },
          onError: function(error) {
            console.error('Add to cart error:', error);
            if (window.publish && window.PUB_SUB_EVENTS) {
              try { window.publish(window.PUB_SUB_EVENTS.cartError, { source: 'product-form', message: (error && error.message) ? error.message : String(error), errors: null, error: error }); } catch(e) {}
            }
            if (window.showGSCartError) {
              window.showGSCartError(error && error.message ? error.message : '');
            } else {
              document.dispatchEvent(new CustomEvent('cart:open'));
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              updateButtonPrice();
            }
          }
        }
      }));
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('[data-scroll-to]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.getAttribute('href');
        var target = document.querySelector(targetId);
        if (target) {
          var headerOffset = 120;
          var elementPosition = target.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.scrollY - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  function normalizeReviewCopy() {
    var locale = (document.documentElement.lang || 'en').slice(0, 2);
    var trustCopy = {
      fr: '+5000 clients satisfaits',
      en: '+5000 happy customers',
      es: '+5000 clientas satisfechas',
      de: '+5000 zufriedene Kundinnen',
      it: '+5000 clienti soddisfatti'
    };
    var leggingCopy = {
      fr: 'Noté <strong>4,8/5</strong> par <strong>+5 000 clientes</strong>',
      en: 'Rated <strong>4.8/5</strong> by <strong>+5,000 customers</strong>',
      es: 'Valorado <strong>4,8/5</strong> por <strong>+5.000 clientas</strong>',
      de: 'Bewertet mit <strong>4,8/5</strong> von <strong>+5.000 Kundinnen</strong>',
      it: 'Valutato <strong>4,8/5</strong> da <strong>+5.000 clienti</strong>'
    };
    var oldCountPattern = /(?:\+600|Trustpilot|\+50(?:[\s\u00a0\u202f,.])*000|\+23(?:[\s\u00a0\u202f,.])*000)/i;

    document.querySelectorAll('.product-trust-row').forEach(function(row) {
      row.querySelectorAll('.separator, .trustpilot-logo').forEach(function(el) {
        el.remove();
      });

      var reviews = row.querySelector('.reviews');
      if (!reviews) return;

      var text = reviews.textContent.replace(/\s+/g, ' ').trim();
      if (oldCountPattern.test(text)) {
        reviews.textContent = trustCopy[locale] || trustCopy.en;
      }
    });

    document.querySelectorAll('.product-social-proof .psp-text').forEach(function(el) {
      var text = el.textContent.replace(/\s+/g, ' ').trim();
      if (/\+50(?:[\s\u00a0\u202f,.])*000/.test(text)) {
        el.innerHTML = leggingCopy[locale] || leggingCopy.en;
      }
    });
  }

  function init() {
    initGallery();
    initVariants();
    initAccordion();
    initFaq();
    initAddons();
    initSmoothScroll();
    normalizeReviewCopy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
